(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name requestRespectedReport.controller:RequestRespectedReportCtrl
   *
   * @description
   *
   */
  angular
    .module('requestRespectedReport')
    .controller('requestRespectedReportCtrl', RequestRespectedReportCtrl);

  function RequestRespectedReportCtrl(CommonMasterData, $sce, CommonLogicService, BiddingService) {
    var vm = this;
    vm.ctrlName = 'RequestRespectedReportCtrl';
    vm.model = {
      searchPanelToggle: true,
      searchCriteria: {
        crewType: null,
        cycle: null,
        cyclePriorityGroup: null
      },
      masterList: {
        crewTypeList: [],
        cyclesList: [],
      },
      initialSearchDone: false,
      reportDataURL: null,
      reportServerBaseUrl: null
    };


    vm.clickOnSearch = function () {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };
    // submit search
    vm.submitSearch = function (params) {
      searchRequestRespectedReport(params);
    };

    function searchRequestRespectedReport(param) {
      vm.model.initialSearchDone = true;
      if (isValidSearchParams(param)) {
        vm.model.searchCriteria = param;
        vm.model.searchPanelToggle = false;
        var rptDesign = "request_respected_report.rptdesign";
        var url = CommonLogicService.getReportUrl(rptDesign, getSearchParamMap(param));
        vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
      }
    }

    function isValidSearchParams(params) {
      if (!!vm.model.searchCriteria.crewType && !!vm.model.searchCriteria.cycle) {
        return true;
      }
      return false;
    }

    function getSearchParamMap(param) {
      var searchParamMap = {};
      searchParamMap["crewTypeCode"] = param.crewType.crewTypeCode;
      searchParamMap["cycleId"] = param.cycle.cycleId;
      searchParamMap["priorityGroup"] = param.cycle.crewGroupCode.substr(0,1);
      searchParamMap["referrer"] = window.location.origin;


      return searchParamMap;
    }

    (function loadCrewTypes() {
      CommonMasterData.getCrewTypeList(
        function (crewTypes) {
          vm.model.masterList.crewTypeList = crewTypes;
        },
        function () {
          console.log('Crew type retrieval error');
        }
      );
    })();

    (function loadRosterCycle() {
      BiddingService.searchCycleMasterData(
        function (cyclesList) {
          vm.model.masterList.cyclesList = cyclesList;
        },
        function () {
          console.log('Roster Cycle retrieval error');
        }
      );
    })();


  }
}());
